import EnumBase from './Base';

export default function metaFieldCompetenceEnum(){
  return new EnumBase([
    {id: 'record',        name: 'Registro'},
    {id: 'items',         name: 'Itens do registro'},
    {id: 'record_items',  name: 'Registro e itens'}
  ]);
}
